// extracted by mini-css-extract-plugin
export default {"brochure":"Brochure_brochure__qGm2m"};